export function contactLabel(email?: string | null, phone?: string | null): string {
  return email || phone || '—'
}
